import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

function ReminderDays({ days }) {
    const dayIndexes = {
        'Sunday': 0,
        'Monday': 1,
        'Tuesday': 2,
        'Wednesday': 3,
        'Thursday': 4,
        'Friday': 5,
        'Saturday': 6,
    };

    const activeDayIndexes = days.map(day => dayIndexes[day]);
    const dayArr = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    return (
        <ReminderDaysParent>
            {dayArr.map((day, index) => {
                const isActive = activeDayIndexes.includes(index);
                return (
                    <View key={index} style={{ marginRight: 4 }}>
                        {isActive ? (
                            <ActiveDayContainer>
                                <ActiveDay>{day}</ActiveDay>
                            </ActiveDayContainer>
                        ) : (
                            <InactiveDayContainer>
                                <InactiveDay>{day}</InactiveDay>
                            </InactiveDayContainer>
                        )}
                    </View>
                );
            })}
        </ReminderDaysParent>
    );
}

// Styled components remain unchanged
export const ReminderDaysParent = styled.View`
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding-left: 25px;
  padding-right: 25px;
`;
export const ActiveDayContainer = styled.View`
  width: 30px;
  height: 30px;
  border-radius:5px;
  background:#c5deff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InactiveDayContainer = styled.View`
  width: 30px;
  height: 30px;
  border-radius:5px;
  background:#e8e9ea;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ActiveDay = styled.Text`
  font-size: 14px;
  font-family: 'Montserrat-EB';
  color: #2d366e;
`;

export const InactiveDay = styled.Text`
  font-size: 14px;
  font-family: 'Montserrat-EB';
  color: #c4c6c7;
`;


export default ReminderDays;